// 購入履歴（/sales-history）の .priceb から class を外す。
// おちゃのこ「アクセス解析タグ設定」欄に直書きされていたものの引き取り先（Issue #53）。
//
// ★ 何のための処理か分かっていない（購入履歴の価格表示の見た目を素にする、以上のことは不明）。
//   目的が分かるまでは挙動を変えずにそのまま移す。田口さんから目的の回答が出たら削除やリファクタを検討する。

export default function salesHistoryPrice(): void {
  document.querySelectorAll('.priceb').forEach((el) => el.removeAttribute('class'))
}
